import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../Context/AuthenticateProvider";
import { useSelector } from "react-redux";

const PublicRouter = () => {
  const { isAuthenticated } = useAuth();
  const user = useSelector(s => s.customer.customer);
  console.log(user , 'public ------------')
  if (isAuthenticated) {
    if (user?.user?.role === "admin") return <Navigate to="/admin/dashboard" replace />;
    if (user?.user?.role === "business" && !user?.profile_completed) return <Navigate to="/user/reg" replace />;
  }
  return <Outlet />;
};

export default PublicRouter;
